import { Divider, Skeleton } from "antd"

export const SectionsSkeleton = () =>  (
    <>
        <Skeleton active />
        <Divider />

        <Skeleton active />
        <Divider />

        <Skeleton active />
        <Divider />
    </>
)

